<template>
  <div class="w-full h-full">
    <form
      @submit.prevent="submitPayment"
      @click.stop
      class="w-full h-auto bg-primary2 p-5 hidden"
    >
      <div class="flex flex-col gap-3 lg:gap-5">
        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold text-heading capitalize">
              financing information
            </h2>
            <div>
              <button
                v-if="submitAdditional == true"
                @click="toggleEdit"
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Edit
              </button>
              <button
                v-if="toggle_edit == true"
                @click="
                  disableStatus = true;
                  submitAdditional = true;
                  toggle_edit = false;
                "
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Close
              </button>
            </div>
          </div>
          <!-- <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
            <div class="w-full lg:w-1/2 flex flex-col gap-3">
              <label for="education_loan"  class="text-sm input_label"
                >Do you want to opt for an education loan?
                <span class="span-color">*</span></label
              >
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                v-model="education_loan"
                :disabled="disableStatus"
                @change="educationLoan"
              >
                <option value="" disabled selected>Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div> -->
        </div>
        <div v-if="loan_status == true">
          <div>
            <div>
              <h2 class="text-left text-xl text-heading">Dear Applicant,</h2>
              <p class="py-2 lg:py-4 text-sm input_text">
                You can pay the Non Refundable Course fee for the preferred
                program through Online Payment Gateway Mode using valid Credit
                Card / Debit Card / Net Banking / UPI facility to process
                further.
              </p>
            </div>
            <div>
              <h2 class="text-left text-xl text-heading">
                Declaration by the Applicant:
              </h2>
              <p class="py-2 lg:py-4 text-sm input_text">
                I have understood that course fee procedure and have the Credit
                / Debit cards or the required details for UPI / Net Banking for
                Online Payment Gateway Options
              </p>
            </div>
            <div>
              <h2 class="text-left text-xl text-heading">
                I understand that the fee amount once paid by me will be
                non-refundable
              </h2>
              <div class="flex gap-2 items-center">
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="checkbox"
                  name=""
                  v-model="agreed_payment"
                  :disabled="disableStatus"
                  required
                /><span class="py-2 lg:py-4 text-sm input_text"> I Agree</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- loan scheme details  -->
          <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold text-heading">
              Consumer Loan Details:This information is required to initiate
              loan process with the Financial firms
            </h2>
            <div class="w-full lg:w-1/2 flex flex-col gap-3">
              <label for="scheme" class="text-sm input_label"
                >Scheme <span class="span-color">*</span></label
              >
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                v-model="scheme"
                :disabled="disableStatus"
              >
                <option value="" selected disabled>Select</option>
                <option
                  v-for="schemes in scheme_list"
                  :key="schemes.id"
                  :value="schemes.id"
                >
                  {{ schemes.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- Employment Details  -->
          <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold text-heading">
              Employment Details
            </h2>
            <div
              class="w-full flex flex-col gap-3 lg:flex-row lg:justify-between"
            >
              <div class="w-full flex flex-col gap-3">
                <label for="employment_type" class="text-sm input_label"
                  >Employment Type <span class="span-color">*</span></label
                >
                <select
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :disabled="disableStatus"
                  v-model="employment_type"
                >
                  <option value="" selected disabled>Select</option>
                  <option value="Salaried">Salaried</option>
                  <option value="UnSalaried">UnSalaried</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="company_name" class="text-sm input_label"
                  >Company Name <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="company_name"
                  :disabled="disableStatus"
                  placeholder="Company Name"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="monthly_income" class="text-sm input_label"
                  >Monthly Income <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="monthly_income"
                  :disabled="disableStatus"
                  placeholder="Monthly Income"
                  required
                />
              </div>
            </div>
          </div>
          <!-- bank details  -->
          <div class="flex flex-col gap-2 lg:gap-4">
            <h2 class="text-xl font-semibold text-heading">
              Bank Details -kindly provide below bank details to initiate the
              loan process
            </h2>
            <div class="flex flex-col gap-3 lg:gap-6">
              <div
                class="w-full flex flex-col gap-3 lg:flex-row lg:justify-between"
              >
                <div class="w-full flex flex-col gap-3">
                  <label for="selected_bank" class="text-sm input_label"
                    >Select Bank <span class="span-color">*</span></label
                  >
                  <select
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    aria-label="Default select example"
                    required
                    :disabled="disableStatus"
                    v-model="selected_bank"
                  >
                    <option value="" selected disabled>Select Bank</option>
                    <option
                      v-for="bank in bank_list"
                      :key="bank.id"
                      :value="bank.id"
                    >
                      {{ bank.name }}
                    </option>
                  </select>
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="ifsc_code" class="text-sm input_label"
                    >IFSC Code <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    v-model="ifsc_code"
                    placeholder="IFSC code"
                    required
                  />
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="bank_name" class="text-sm input_label"
                    >Bank Name <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    v-model="bank_name"
                    placeholder="Bank Name"
                    required
                  />
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="branch_name" class="text-sm input_label"
                    >Branch Name <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    v-model="branch_name"
                    placeholder="Branch Name"
                    required
                  />
                </div>
              </div>
              <div
                class="w-full flex flex-col gap-3 lg:flex-row lg:justify-between"
              >
                <div class="w-full flex flex-col gap-3">
                  <label for="account_number" class="text-sm input_label"
                    >Bank Account Number
                    <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    maxlength="15"
                    v-model="account_number"
                    placeholder="Account Number"
                    required
                  />
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="account_holder_name" class="text-sm input_label"
                    >Account Holder Name
                    <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    v-model="account_holder_name"
                    placeholder="Account Holder Name"
                    required
                  />
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="account_type" class="text-sm input_label"
                    >Account Type <span class="span-color">*</span></label
                  >
                  <select
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    aria-label="Default select example"
                    required
                    :disabled="disableStatus"
                    v-model="account_type"
                  >
                    <option value="" selected disabled>
                      Select Account Type
                    </option>
                    <option value="Saving">Savings</option>
                    <option value="Current">Current</option>
                    <option value="Salary">Salary</option>
                  </select>
                </div>
              </div>
              <div
                class="w-full flex flex-col gap-3 lg:flex-row lg:justify-between"
              >
                <div class="w-full flex flex-col gap-3">
                  <label for="pan_number" class="text-sm input_label"
                    >Pan Card Number <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="text"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    :disabled="disableStatus"
                    v-model="pan_number"
                    maxlength="10"
                    placeholder="Pan card number"
                    required
                  />
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="aadhar_card" class="text-sm input_label"
                    >Upload Aadhar Card <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="file"
                    :disabled="disableStatus"
                    @change="onFileUpload('aadhar', $event)"
                    accept=".jpg, .jpeg, .pdf"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    required
                  />
                  <a
                    v-if="upload_aadhar_show === true"
                    :href="file_aadhar"
                    target="_blank"
                    :download="file_aadhar"
                    class="text-sm text-gray-600"
                    rel="noopener noreferrer"
                  >
                    Open Aadhar Card
                  </a>
                  <p class="text-[10px] input_text break-words leading-normal">
                    Max upload limit 3 MB & in PDF, ..jpeg or ..jpgformat
                    only.Size should be applied between 50 KB to 3 MB.less than
                    or more than the give size will be rejected
                  </p>
                </div>
                <div class="w-full flex flex-col gap-3">
                  <label for="pan_card" class="text-sm input_label"
                    >Upload Pan card <span class="span-color">*</span></label
                  >
                  <input
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    type="file"
                    :disabled="disableStatus"
                    @change="onFileUpload('pan', $event)"
                    accept=".jpg, .jpeg, .pdf"
                    class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    required
                  />
                  <a
                    v-if="upload_pan_show === true"
                    :href="file_pan"
                    target="_blank"
                    :download="file_pan"
                    class="text-sm text-gray-600"
                    rel="noopener noreferrer"
                  >
                    Open Pan card
                  </a>
                  <p class="text-[10px] input_text break-words leading-normal">
                    Max upload limit 3 MB & in PDF, ..jpeg or ..jpgformat
                    only.Size should be applied between 50 KB to 3 MB.less than
                    or more than the give size will be rejected
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <h2 class="text-left text-xl text-heading">Dear Applicant,</h2>
              <div class="py-2 lg:py-4 text-sm input_text">
                <p>Click on the Pay Fee / Apply For Loan button now</p>
                <p>
                  In case you have a Scholarship Coupon node shared with you by
                  your Learning Advisor,plrase enter the same
                </p>
                <p>Click on Apply For Loan button</p>
              </div>
            </div>
            <div>
              <h2 class="text-left text-xl text-heading">
                Further steps for Loan:
              </h2>
              <ul
                class="py-2 lg:py-4 text-sm input_text list-decimal px-2 lg:px-4"
              >
                <li>
                  You will receive a verification call to confirm your
                  application and documents
                </li>
                <li>Post verification , you must make a down payment</li>
                <li>Post clearance from loan, an invoice will be generated</li>
                <li>Confirmation on completion of enrollment</li>
                <li>
                  Receiving login credentials to the LMS after completing the
                  admission process
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2 lg:flex-row lg:gap-4">
          <div class="w-full flex flex-col gap-3">
            <label for="program" class="text-sm input_label"
              >Fee Preference <span class="span-color">*</span></label
            >
            <div class="flex flex-col gap-2 lg:flex-row lg;gap-4">
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :disabled="disableStatus"
                v-model="selected_fee_preference"
              >
                <option value="" selected disabled>Select</option>
                <option value="Yearly Fee">Yearly Fee</option>
                <option value="Program Fee">Program Fee</option>
              </select>
              <div class="w-full">
                <button
                  v-if="payment_recieved == false"
                  @click.prevent="makePayment"
                  type="button"
                  :disabled="disableStatus"
                  class="btn px-4 py-2 rounded-md text-sm"
                >
                  Pay Now / Apply for Loan
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.toggle_payment_table"
          class="w-full flex flex-col gap-3 lg:gap-5"
        >
          <h2 class="text-xl text-left text-heading">Payment Details</h2>
          <table class="w-full text-sm border-collapse">
            <thead>
              <tr class="text">
                <th class="p-4 bg-primary rounded-l-lg">Order Id</th>
                <th class="p-4 bg-primary">Payment Id</th>
                <th class="p-4 bg-primary">Amount</th>
                <th class="p-4 bg-primary">Payment Status</th>
                <th class="p-4 bg-primary rounded-r-lg">Currency</th>
              </tr>
            </thead>
            <tbody class="input_text">
              <tr class="border-b-2">
                <td class="p-4">{{ this.payment_data_razor.order_id }}</td>
                <td class="p-4">{{ this.payment_data_razor.payment_id }}</td>
                <td class="p-4">{{ this.payment_data_razor.amount }}</td>
                <td class="p-4">{{ this.payment_data_razor.status }}</td>
                <td class="p-4">{{ this.payment_data_razor.currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="submit_button == false" class="flex justify-start w-full">
          <div class="text-xl">
            <p v-if="message" class="text-success">{{ message }}</p>
            <p v-if="error_message" class="text-error">{{ error_message }}</p>
          </div>
          <!-- <div class="flex justify-end items-center">
            <button
              :disabled="disableStatus"
              type="submit"
              class="px-5 py-1 btn text-[16px] rounded-md"
            >
              Save
            </button>
          </div> -->
        </div>
      </div>
    </form>
    <div v-if="loader == true" class="w-full h-full"></div>
    <form
      v-else
      @submit.prevent="makePayment"
      @click.stop
      class="w-full h-auto bg-primary2 p-5"
    >
      <div v-if="toggle_payment_table == false">
        <div>
          <h2 class="text-xl font-semibold text-heading capitalize">
            financing information
          </h2>
          <div>
            <h2 class="text-left text-xl text-heading">Dear Applicant,</h2>
            <p class="py-2 lg:py-4 text-sm input_text">
              You can pay the Non Refundable Course fee for the preferred
              program through Online Payment Gateway Mode using valid Credit
              Card / Debit Card / Net Banking / UPI facility to process further.
            </p>
          </div>
          <div>
            <h2 class="text-left text-xl text-heading">
              Declaration by the Applicant:
            </h2>
            <p class="py-2 lg:py-4 text-sm input_text">
              I have understood that course fee procedure and have the Credit /
              Debit cards or the required details for UPI / Net Banking for
              Online Payment Gateway Options
            </p>
          </div>
          <div>
            <h2 class="text-left text-xl text-heading">
              I understand that the fee amount once paid by me will be
              non-refundable
            </h2>
            <div class="flex gap-2 items-center">
              <input
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                type="checkbox"
                name=""
                v-model="agreed_payment"
                :disabled="disableStatus"
                required
              /><span class="py-2 lg:py-4 text-sm input_text"> I Agree</span>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2 lg:flex-row lg:gap-4">
          <div class="w-full flex flex-col gap-3">
            <label for="program" class="text-sm input_label"
              >Fee Preference <span class="span-color">*</span></label
            >
            <div class="flex flex-col gap-2 lg:flex-row lg;gap-4">
              <select
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :disabled="disableStatus"
                v-model="selected_fee_preference"
              >
                <option value="" selected disabled>Select</option>
                <option
                  v-for="fee in get_fee_perfernce"
                  :key="fee.id"
                  :value="fee.id"
                >
                  {{ fee.name }}
                </option>
              </select>
              <div class="w-full">
                <button
                  v-if="payment_recieved == false"
                  type="submit"
                  :disabled="disableStatus"
                  class="btn px-4 py-2 rounded-md text-sm"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xl">
        <p v-if="message" class="text-success">{{ message }}</p>
        <p v-if="error_message" class="text-error">{{ error_message }}</p>
      </div>

      <div
        v-if="this.toggle_payment_table"
        class="w-full flex flex-col gap-3 lg:gap-5"
      >
        <h2 class="text-xl text-left text-heading">Payment Details</h2>
        <div class="w-full overflow-x-scroll">
          <table class="w-full text-sm border-collapse">
            <thead>
              <tr class="text">
                <th class="p-4 bg-primary rounded-l-lg">Order Id</th>
                <th class="p-4 bg-primary">Payment Id</th>
                <th class="p-4 bg-primary">Amount</th>
                <th class="p-4 bg-primary">Payment Status</th>
                <th class="p-4 bg-primary rounded-r-lg">Currency</th>
              </tr>
            </thead>
            <tbody class="input_text">
              <tr class="border-b-2">
                <td class="p-4">{{ this.payment_data_razor.order_id }}</td>
                <td class="p-4">{{ this.payment_data_razor.payment_id }}</td>
                <td class="p-4">{{ this.payment_data_razor.amount }}</td>
                <td class="p-4">{{ this.payment_data_razor.status }}</td>
                <td class="p-4">{{ this.payment_data_razor.currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "PaymentView",
  data() {
    return {
      education_loan: "",
      scheme: "",
      employment_type: "",
      company_name: "",
      monthly_income: "",
      selected_bank: "",
      ifsc_code: "",
      bank_name: "",
      branch_name: "",
      pan_number: "",
      account_number: "",
      account_holder_name: "nan",
      account_type: "",
      selected_fee_preference: "",
      agreed_payment: "",
      loan_status: true,
      scheme_list: [],
      bank_list: [],
      file_aadhar: null,
      file_pan: null,
      is_form_four_filled: false,
      get_payment_list: [],
      amount: "",
      submitAdditional: false,
      disableStatus: false,
      message: "",
      payment_response: [],
      upload_aadhar_show: false,
      upload_pan_show: false,
      submit_button: false,
      toggle_edit: false,
      payment_recieved: false,
      error_message: "",
      payment_data_razor: [],
      toggle_payment_table: false,
      get_fee_perfernce: [],
      name: "",
      loader: true,
    };
  },
  async created() {
    await this.getPaymentRazor();
    await this.getBank();
    await this.getScheme();
    await this.getPaymentDetails();
    await this.getFeePreference();
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    // /bank-list/
    async getBank() {
      await axios
        .get(`${process.env.VUE_APP_API}/bank-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.bank_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async getScheme() {
      await axios
        .get(`${process.env.VUE_APP_API}/scheme-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.scheme_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    // get fee preference
    async getFeePreference() {
      await axios
        .get(`${process.env.VUE_APP_API}/fee-payment-list/`)
        .then((fee) => {
          if (fee.data.status == 200) {
            this.get_fee_perfernce = fee.data.data;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    onFileUpload(type, event) {
      const file = event.target.files[0];
      const maxFileSize = 3 * 1024 * 1024;
      const minFileSize = 50 * 1024;
      if (file.size > maxFileSize) {
        alert("File size exceeds 3MB. Please upload a smaller file.");
        event.target.value = "";
        return;
      }
      if (file.size < minFileSize) {
        alert(
          "File size minimun 50kb. Please upload a larger file size between 50 KB to 3 MB."
        );
        event.target.value = "";
        return;
      }
      if (type === "aadhar") {
        this.file_aadhar = file;
      } else if (type === "pan") {
        this.file_pan = file;
      }
    },
    submitPayment() {
      let formData = new FormData();
      formData.append("upload_aadhar", this.file_aadhar);
      formData.append("upload_pan", this.file_pan);
      formData.append("educational_loan", this.education_loan);
      formData.append("non_refundable", this.agreed_payment);
      formData.append("scheme", this.scheme);
      formData.append("company_name", this.company_name);
      formData.append("monthly_income", this.monthly_income);
      formData.append("bank", this.selected_bank);
      formData.append("ifsc_code", this.ifsc_code);
      formData.append("bank_name", this.bank_name);
      formData.append("account_number", this.account_number);
      formData.append("account_holder_name", this.account_holder_name);
      formData.append("account_type", this.account_type);
      formData.append("pan_card_number", this.pan_number);
      formData.append("fee_preference", this.selected_fee_preference);
      formData.append("is_form_four_filled", this.is_form_four_filled);
      formData.append("branch_name", this.branch_name);
      formData.append("employment_type", this.employment_type);
      if (this.submitAdditional == false) {
        axios
          .post(
            `${process.env.VUE_APP_API}/paymentinformation/create/?Key=${this.userInfo.data.token}`,
            formData
          )
          .then((resp) => {
            console.log();
            if (resp.data.status == 200) {
              this.disableStatus = true;
              this.submitAdditional = true;
              this.message = resp.data.message;
              // this.getPaymentDetails();
              this.$emit("formCompleted");
              console.log("formData", formdata);
              setTimeout(() => {
                this.message = "";
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API}/paymentinformation/retrive-update-delete/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
            formData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              console.log("patch data", formData);
              // this.getPaymentDetails();
              this.disableStatus = true;
              this.toggle_edit = false;
              this.message = resp.data.message;
              setTimeout(() => {
                this.message = "";
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },

    // get payment details
    async getPaymentDetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/paymentinformation/retrive-update-delete/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            const payments = resp.data.data;
            console.log("payments", payments);
            // Make sure the response data exists
            if (payments.user != null) {
              this.upload_aadhar_show = true;
              this.upload_pan_show = true;
              this.get_payment_list = payments;
              this.education_loan =
                this.get_payment_list.educational_loan ||
                payments.educational_loan;
              this.agreed_payment =
                this.get_payment_list.non_refundable || payments.non_refundable;
              this.scheme = this.get_payment_list.scheme || payments.scheme;
              this.company_name =
                this.get_payment_list.company_name || payments.company_name;
              this.monthly_income =
                this.get_payment_list.monthly_income || payments.monthly_income;
              this.selected_bank = this.get_payment_list.bank || payments.bank;
              this.ifsc_code =
                this.get_payment_list.ifsc_code || payments.ifsc_code;
              this.bank_name =
                this.get_payment_list.bank_name || payments.bank_name;
              this.account_number =
                this.get_payment_list.account_number || payments.account_number;
              this.account_type =
                this.get_payment_list.account_type || payments.account_type;
              this.pan_number =
                this.get_payment_list.pan_card_number ||
                payments.pan_card_number;
              this.selected_fee_preference =
                this.get_payment_list.fee_preference || payments.fee_preference;
              this.is_form_four_filled =
                this.get_payment_list.is_form_four_filled ||
                payments.is_form_four_filled;
              this.branch_name =
                this.get_payment_list.branch_name || payments.branch_name;
              this.account_holder_name =
                this.get_payment_list.account_holder_name ||
                payments.account_holder_name;
              this.employment_type =
                this.get_payment_list.employment_type ||
                payments.employment_type;
              this.file_aadhar = this.getFileUrl(
                this.get_payment_list.upload_aadhar || payments.upload_aadhar
              );
              this.file_pan = this.getFileUrl(
                this.get_payment_list.upload_pan || payments.upload_pan
              );
              // if (
              //   this.get_payment_list.is_form_completed &&
              //   this.get_payment_list.is_form_four_filled
              // ) {
              //   this.submitAdditional = false;
              //   this.toggle_edit = false;
              //   this.disableStatus = true;
              //   this.submit_button = true;
              // } else if (
              //   this.get_payment_list.is_form_completed != true &&
              //   this.get_payment_list.is_form_four_filled == true
              // ) {
              //   this.toggle_edit = false;
              //   this.submitAdditional = true;

              //   this.disableStatus = true;
              // } else {
              //   this.submitAdditional = false;
              //   this.disableStatus = false;
              // }
            }
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    educationLoan() {
      if (this.education_loan === "false") {
        this.loan_status = true;
      } else {
        this.loan_status = false;
      }
    },
    async makePayment() {
      const razorpayment = {
        fee_preference_id: this.selected_fee_preference,
        name: this.name,
      };
      console.log("razor", razorpayment);
      axios
        .post(`${process.env.VUE_APP_API}/start-payment/`, razorpayment)
        .then((resp) => {
          if (resp.status == 200) {
            this.payment_response = resp.data;
            console.log("payment_response", this.payment_response);

            const options = {
              key: process.env.VUE_APP_RAZORPAY_KEY,
              amount: this.payment_response.payment.amount,
              name: "Your Company Name",
              description: "Test Transaction",
              order_id: this.payment_response.order.order_id,
              handler: (response) => {
                console.log("response from razorpay", response);
                const payment_id = response.razorpay_payment_id;
                const order_id = response.razorpay_order_id;
                const signature = response.razorpay_signature;
                const razor_pay = {
                  user_id: `${this.userInfo.data.user.id}`,
                  razorpay_payment_id: payment_id,
                  razorpay_order_id: order_id,
                  razorpay_signature: signature,
                };
                const response_razorpay = response;
                axios
                  .post(
                    `${process.env.VUE_APP_API}/handle-payment-success/`,
                    razor_pay
                  )
                  .then((resp) => {
                    if (resp.data.status == 200) {
                      this.message = resp.data.message;
                      this.payment_recieved = true;
                      this.getPaymentRazor();
                      this.$emit("formCompleted");
                      setTimeout(() => {
                        this.message = "";
                      }, 3000);
                    } else if (resp.data.status == 400) {
                      this.error_message = resp.data.message;
                      setTimeout(() => {
                        this.error_message = "";
                      }, 3000);
                    }
                  })
                  .catch((err) => {
                    console.log("error", err);
                  });
              },
              prefill: {
                // name: this.account_holder_name,
                name: "",
                email: "",
                contact: "",
              },
              theme: {
                color: "#3399cc",
              },
              method: {
                upi: true,
                netbanking: true,
                card: true,
                wallet: true,
              },
            };
            const rzp = new Razorpay(options);
            rzp.open();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    getFileUrl(file) {
      return `${process.env.VUE_APP_API}${file}`;
    },
    getPaymentRazor() {
      axios
        .get(
          `${process.env.VUE_APP_API}/handle-payment-success-list/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.loader = false;
            this.payment_data_razor = resp.data.data;
            this.toggle_payment_table = true;
            if (
              this.payment_data_razor.is_form_completed &&
              this.payment_data_razor.is_paid
            ) {
              this.submitAdditional = false;
              this.toggle_edit = false;
              this.disableStatus = true;
              this.submit_button = true;
            } else if (
              this.payment_data_razor.is_form_completed != true &&
              this.payment_data_razor.is_paid == true
            ) {
              this.toggle_edit = false;
              this.submitAdditional = true;

              this.disableStatus = true;
            } else {
              this.submitAdditional = false;
              this.disableStatus = false;
            }
          } else {
            this.toggle_payment_table = false;
            this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style></style>
